import { render, staticRenderFns } from "./z-verification.vue?vue&type=template&id=631ceb3c&"
import script from "./z-verification.vue?vue&type=script&lang=js&"
export * from "./z-verification.vue?vue&type=script&lang=js&"
import style0 from "./z-verification.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports